export type RapierModule = typeof import("@dimforge/rapier3d");

let initialization: Promise<RapierModule> | null = null;

function isNodeRuntime(): boolean {
  return typeof process !== "undefined" && process.release?.name === "node";
}

/** Loads and initializes Rapier's WASM exactly once for this JS realm. */
export function initializeRapier(): Promise<RapierModule> {
  if (initialization === null) {
    if (isNodeRuntime()) {
      // The non-compat package publishes a browser-only `module` entry and no
      // Node `main`/`exports` entry. Keep the already-approved compat package
      // as a test/tool adapter without placing it in the browser graph. The
      // computed specifier is intentionally ignored by Vite; this branch is
      // unreachable in the browser build.
      const nodePackageName = "@dimforge/rapier3d-compat";
      initialization = import(/* @vite-ignore */ nodePackageName).then(
        async (module) => {
          await module.init();
          return module as unknown as RapierModule;
        },
      );
    } else {
      // The non-compat package imports its WASM module as a separate browser
      // asset, so resolving this dynamic import is the initialization barrier.
      initialization = import("@dimforge/rapier3d");
    }
  }
  return initialization;
}
